<template>
  <div class="bg-gray-200 font-opensans rounded-lg shadow-lg">
    <div
      class="py-2 px-2 text-center font-bold uppercase tracking-wide bg-mi-blue-500 rounded-t-lg text-gray-100 truncate"
    >
      {{ header }}
    </div>
    <input
      type="text"
      placeholder="Filteren op gebruikersnaam of e-mail"
      v-model="filter"
      class="bg-gray-100 w-full h-10 px-5 pr-10 rounded-lg
    text-sm focus:outline-none border-gray-700 border font-opensans mt-4"
    />
    <table class="m-4">
      <thead>
        <tr>
          <th>Gebruikernaam</th>
          <th>E-mail</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(user, index) in filteredRows"
          :key="index"
          @click="openUser(user.id)"
          class="cursor-pointer"
        >
          <td>{{ user.username }}</td>
          <td>{{ user.email }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "UsersCard",
  data: function() {
    return {
      header: "Gebruikers",
      filter: ""
    };
  },
  computed: {
    ...mapState({
      users: state => state.backend_data.users
    }),
    filteredRows() {
      return this.users.filter(user => {
        const username = user.username.toString().toLowerCase();
        const email = user.email.toLowerCase();
        const searchTerm = this.filter.toLowerCase();

        return username.includes(searchTerm) || email.includes(searchTerm);
      });
    }
  },

  mounted: function() {
    this.$store.dispatch("loadUsers");
  },
  methods: {
    openUser: function(id) {
      this.$router.push({ name: "EditUser", params: { id: id } });
    }
  }
};
</script>
